(() => {
  const init = (root) => {
    if (root.dataset.computerDirectoryReady === 'true') return;
    root.dataset.computerDirectoryReady = 'true';

    const filters = Array.from(root.querySelectorAll('[data-computer-filter]'));
    const items = Array.from(root.querySelectorAll('[data-computer-item]'));
    const heading = root.querySelector('[data-computer-results-heading]');
    const status = root.querySelector('[data-computer-results-status]');
    const searchForm = root.querySelector('[data-computer-search-form]');
    const searchInput = root.querySelector('[data-computer-search]');
    const clearButton = root.querySelector('[data-computer-search-clear]');
    const noResults = root.querySelector('[data-computer-no-results]');

    if (!items.length) return;

    let activeBrand = 'all';
    const allHeading = root.dataset.directoryAllHeading || 'All Computer Skins';
    const labelSuffix = root.dataset.directoryLabelSuffix || ' Computer Skins';
    let activeLabel = allHeading;

    const normalize = (value) => String(value || '').trim().toLowerCase();

    const applyFilters = () => {
      const query = normalize(searchInput?.value);
      let visible = 0;

      items.forEach((item) => {
        const card = item.querySelector('[data-search]');
        const searchableText = normalize(`${card?.dataset.search || ''} ${item.dataset.computerBrand || ''}`);
        const matchesBrand = activeBrand === 'all' || item.dataset.computerBrand === activeBrand;
        const matchesSearch = !query || searchableText.includes(query);
        const show = matchesBrand && matchesSearch;

        item.hidden = !show;
        if (show) visible += 1;
      });

      filters.forEach((button) => {
        const active = button.dataset.computerFilter === activeBrand;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      if (heading) {
        heading.textContent = activeBrand === 'all' ? allHeading : `${activeLabel}${labelSuffix}`;
      }
      if (status) {
        const searchStatus = query ? ` matching “${searchInput.value.trim()}”` : '';
        status.textContent = `${visible} ${visible === 1 ? 'item' : 'items'}${searchStatus}, newest first`;
      }
      if (clearButton) clearButton.hidden = !query;
      if (noResults) noResults.hidden = visible !== 0;
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        activeBrand = button.dataset.computerFilter || 'all';
        activeLabel = button.dataset.label || allHeading;
        applyFilters();
      });
    });

    searchForm?.addEventListener('submit', (event) => event.preventDefault());
    searchInput?.addEventListener('input', applyFilters);
    clearButton?.addEventListener('click', () => {
      searchInput.value = '';
      applyFilters();
      searchInput.focus();
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-sw-computer-directory]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
